export * from './desktopHeader'
export * from './mobileHeader'
export * from './status'
export * from './promos'



// WEBPACK FOOTER //
// ./src/components/header/index.js